import { Action } from "redux";
import { ActionCreator } from "typedActions";
import { HeadDefinition } from "./models";

export const HEAD_UPDATED = "HEAD_UPDATED"
export interface HeadUpdated extends Action {
    payload: HeadDefinition
}
export const CreateUpdatedHeadAction = ActionCreator<HeadUpdated>(HEAD_UPDATED);
